"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.versionAgnosticProps = exports.assetProperties = exports.TAGS_UPDATED = exports.CATEGORIES_UPDATED = exports.ASSET_STATUS_EDITED = exports.ASSET_NAME_EDITED = exports.ASSET_METADATA_EDITED = exports.ASSET_ICON_EDITED = exports.ASSET_ICON_DELETED = exports.ASSET_DESCRIPTION_EDITED = exports.ASSET_CREATED = exports.ASSET_CONTACT_NAME_EDITED = exports.ASSET_CONTACT_EMAIL_EDITED = void 0;
var basicAssetProperties = ['organizationId', 'groupId', 'assetId', 'version', 'name', 'type'];
var versionAgnosticProps = exports.versionAgnosticProps = function versionAgnosticProps(asset) {
  return {
    groupId: asset.groupId,
    assetId: asset.assetId,
    name: asset.name,
    type: asset.type,
    icon: asset.icon
  };
};
var assetProperties = exports.assetProperties = function assetProperties(asset) {
  var _asset$organization;
  return {
    organizationId: 'organizationId' in asset ? asset.organizationId : (_asset$organization = asset.organization) === null || _asset$organization === void 0 ? void 0 : _asset$organization.id,
    groupId: asset.groupId,
    assetId: asset.assetId,
    version: asset.version,
    name: asset.name,
    type: asset.type,
    originalFormat: 'originalFormat' in asset ? asset.originalFormat : undefined,
    originalFormatVersion: 'originalFormatVersion' in asset ? asset.originalFormatVersion : undefined
  };
};
var ASSET_CREATED = exports.ASSET_CREATED = {
  name: 'Asset created',
  required: basicAssetProperties
};
var ASSET_DESCRIPTION_EDITED = exports.ASSET_DESCRIPTION_EDITED = {
  name: 'Asset description edited',
  required: basicAssetProperties
};
var ASSET_ICON_DELETED = exports.ASSET_ICON_DELETED = {
  name: 'Asset icon deleted',
  required: basicAssetProperties
};
var ASSET_ICON_EDITED = exports.ASSET_ICON_EDITED = {
  name: 'Asset icon edited',
  required: basicAssetProperties
};
var ASSET_CONTACT_NAME_EDITED = exports.ASSET_CONTACT_NAME_EDITED = {
  name: 'Asset contact name edited',
  required: basicAssetProperties
};
var ASSET_CONTACT_EMAIL_EDITED = exports.ASSET_CONTACT_EMAIL_EDITED = {
  name: 'Asset contact email edited',
  required: basicAssetProperties
};
var ASSET_NAME_EDITED = exports.ASSET_NAME_EDITED = {
  name: 'Asset name edited',
  required: basicAssetProperties
};
var ASSET_METADATA_EDITED = exports.ASSET_METADATA_EDITED = {
  name: 'Asset metadata edited',
  required: basicAssetProperties
};
var ASSET_STATUS_EDITED = exports.ASSET_STATUS_EDITED = {
  name: 'Asset status edited',
  required: basicAssetProperties
};
var TAGS_UPDATED = exports.TAGS_UPDATED = 'Tags updated';
var CATEGORIES_UPDATED = exports.CATEGORIES_UPDATED = 'Categories updated';
//# sourceMappingURL=events.js.map